import React from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';
import Toggle from '../../Button/Toggle';
import { numPad } from '../../../Services/helpers';

const fallbackValue = null;
const roundToMinutes = 15;

const AllowedTimes = ({label, innerLabel, name, help, onChange, disabled, validators}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    const value = formData[name] ?? fallbackValue;

    const {isValid, error} = useValidators(value, validators, name, updateValidity);

    const toggleEnabled = (on) => {
        handleChange(on ? {earliest: '07:00', latest: '22:00'} : null);
    }

    const handleChange = (newVal) => {
        updateField(name, newVal);
        onChange && onChange(newVal);
    }

    const changeField = (field, val) => {
        const [hours, minutes] = val.split(':');
        const newMins = (Math.round(minutes/roundToMinutes) * roundToMinutes) % 60;
        const newValue = `${numPad(hours)}:${numPad(newMins)}`;

        handleChange({...(value ?? {}), [field]: newValue});
    }

    const isDisabled = formDisabled || disabled || isSubmitting;

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled}}>

        <Toggle enabled={value !== null} onChange={toggleEnabled} label={innerLabel ?? label} disabled={isDisabled} hideFocusRing />

        {(value !== null) && <>
            <div className="relative flex flex-row mt-4">
                <div className="grow px-2 text-sm text-muted">
                    <input className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6 disabled:text-gray-400 disabled:bg-gray-100"
                        type="time"
                        value={value.earliest}
                        onChange={e => changeField('earliest', e.target.value)}
                        placeholder="Earliest"
                        disabled={isDisabled}
                        step="900"
                    />
                    {/* From */}
                </div>
                <div className="px-2 text-sm text-muted">
                    -
                </div>
                <div className="grow px-2 text-sm text-muted">
                    <input className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6 disabled:text-gray-400 disabled:bg-gray-100"
                        type="time"
                        value={value.latest}
                        onChange={e => changeField('latest', e.target.value)}
                        placeholder="Latest"
                        disabled={isDisabled}
                        step="900"
                    />
                    {/* To */}
                </div>
            </div>
        </>}

    </CommonFieldWrapper>
}

export default AllowedTimes;
